import Vue from 'vue'
import ResourceList from './PartnerResources'

const resourceVue = document.getElementById('partner-resources-vue');

if (resourceVue) {
    new Vue({
        render: h => h(ResourceList),
    }).$mount('#partner-resources-vue')
}




// WEBPACK FOOTER //
// ./App/components/PartnerResources/index.js